import { useTheme } from 'styled-components';
import { DragRule, RoutingRuleTitleStyled } from './RoutingRuleTitle.styles';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { EditableTitle } from 'src/components/atoms';
import { RoutingRuleType } from 'src/graphql';

interface Props {
  rule: RoutingRuleType;
  index: number;
  name: string;
  onSave: () => void;
  updateRule: (name: string) => void;
}

export const RoutingRuleTitle = ({ rule, name, onSave, updateRule }: Props) => {
  const theme = useTheme();
  return (
    <RoutingRuleTitleStyled>
      <DragRule>
        <StyledIcon
          size="20px"
          className="uil-arrows-v"
          color={theme.atlas.semantic.color.type.default}
        />
      </DragRule>
      <EditableTitle
        value={name}
        setValue={(value: string) => updateRule(value)}
        defaultValue="Untitled Rule Name"
        disabled={!rule.disabled}
        onSave={onSave}
        data-testid="rule-name"
      />
    </RoutingRuleTitleStyled>
  );
};
